<template>
  <div class="channels-cont">
    <template v-if="getChannelTypes.length>0">
      <div
          v-for="(channelItem, channelIndex) in getChannelTypes"
          :key="`channel-key-${channelIndex}`"
          class="channel-item"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <channel-icon
                  :channel-data="channelItem"
                  :is-selected="isChannelEnabled(channelItem.id)"
                  :is-disabled="loading"
                  @assign="() => enableChannel(channelItem)"
              />
            </div>
          </template>
          <span>{{ channelItem.label }}</span>
        </v-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import ChannelIcon from "@/components/Settings/Tenants/ChannelIcon.vue";
import {channelMeta} from "@/utilities/DefaultObjects";
import {mapGetters} from "vuex";

export default {
  name: 'ChannelsPanel',
  components: {ChannelIcon},
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    channelList: {
      type: Array,
      default: () => channelMeta,
    },
    enabled: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapGetters("notifications", ["getChannelTypes"]),
  },
  methods: {
    /**
     * Emit the toggle event for the specified channel
     * @param channel {Object} - The channel data of the channel to toggle
     */
    enableChannel(channel) {
      // console.log('channel');
      // console.log(channel);
      this.$emit('toggle', channel);
    },
    /**
     * Check if a channel is enabled as specified by its ID and
     * checked against the list of enabled channels passed as component props
     * @param channelId {String} - The channel's ID to check against
     * @returns {boolean}
     */
    isChannelEnabled(channelId) {
      let isEnabled = false;
      if (!!this.enabled && this.enabled.length > 0) {
        this.enabled.forEach(enabledChannelItem => {
          if (enabledChannelItem.id === channelId) {
            isEnabled = true;
          }
        });
      }
      return isEnabled;
    }
  }
}
</script>

<style lang="scss" scoped>
.channels-cont {
  display: flex;
}
</style>